import React from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FAQS } from '../../data/content';
export function Faq() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-51" data-mp="x4bsak011pz8">
      <div className="mx-auto max-w-3xl" data-id="element-52" data-mp="x5wm27eip4w1">
        <Reveal className="text-center" data-id="element-53" data-mp="121trvjs5msuk">
          <SectionBadge data-id="element-54" data-mp="122ve8kemf1rl">Preguntas frecuentes</SectionBadge>
          <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-55" data-mp="1prxtxmpp2kjg">
            Todo lo que <span className="u-lime" data-id="element-56" data-mp="1uq92zv860r0m">querés saber</span>
          </h2>
        </Reveal>

        <div className="mt-8 space-y-2.5" data-id="element-57" data-mp="1g2xq9q08z0yx">
          {FAQS.map((faq, index) => <Reveal key={faq.q} delay={Math.min(index, 3) * 60} data-id="element-58" data-mp="1l17qif0twrre" data-mpi={index}>
              <details className="group rounded-2xl border border-white/10 bg-ink/90" data-id="element-59" data-mp="1kzefyon3hne4">
                <summary className="flex cursor-pointer list-none items-center gap-4 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime sm:p-5 [&::-webkit-details-marker]:hidden" data-id="element-60" data-mp="28pqx8q48cwhd">
                  <span className="flex-1 text-sm font-bold leading-snug text-snow sm:text-base" data-id="element-61" data-mp="2onw2vp2810om">{faq.q}</span>
                  <PlusIcon className="h-4 w-4 flex-shrink-0 text-lime transition-transform duration-300 group-open:rotate-45" aria-hidden="true" data-id="element-62" data-mp="2yg1vn10arm4v" />
                </summary>
                <p className="px-4 pb-4 text-sm leading-relaxed text-snow-muted sm:px-5 sm:pb-5" data-id="element-63" data-mp="37fx8da9i3p70">{faq.a}</p>
              </details>
            </Reveal>)}
        </div>
      </div>
    </section>;
}